import { CompletionData } from '@/api/manualCalculation/types';
import { IconOpenInNewMS } from '@/constants/icons';
import { Constants } from '@/constants/report';
import { Box, LinearProgress, Typography } from '@mui/material';
import { useHref } from 'react-router-dom';

import { SectionStatusBadge } from '../StatusIndicators';
import { StyledPaper, SummaryMobileStepper, OutlinedButton } from './styles';

interface Props {
  loading: boolean;
  completionData: CompletionData | undefined;
}

export function ScientificTreatmentSummary({
  loading,
  completionData,
}: Props): JSX.Element | null {
  const href = useHref('scientific-treatment');

  if (loading) return <LinearProgress sx={{ mx: 1 }} />;
  if (!completionData) return <Box>{Constants.scientificTreatmentError}</Box>;

  const sectionKeys = Object.keys(completionData?.sections ?? {});
  const totalSections = sectionKeys.length;
  const completeSections = Object.values(completionData?.sections ?? {}).filter(
    (s) => s.status === 'complete'
  ).length;

  return (
    <StyledPaper>
      <Box sx={{ width: '100%', mb: 1 }}>
        <SummaryMobileStepper
          variant="progress"
          steps={101}
          position="static"
          activeStep={Math.round(completionData?.percentage ?? 0)}
          nextButton={<Box />}
          backButton={<Box />}
        />
        <Box display="flex" justifyContent="space-between" my={2} mx={1}>
          <Box display="flex">
            <Typography fontSize="14px" color="#707070">
              {completeSections} de {totalSections} seções completas
            </Typography>
            <Typography mx={1}>&middot;</Typography>
            <Typography color="primary.main" fontSize="14px">
              {completionData?.required_filled ?? 0}/
              {completionData?.required_total ?? 0} campos obrigatórios
            </Typography>
          </Box>
          <Typography fontSize="14px" fontWeight={600} color="primary">
            {completionData?.percentage ?? 0}%
          </Typography>
        </Box>
      </Box>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <OutlinedButton onClick={() => window.open(href, '_blank')}>
          ver respostas
          {IconOpenInNewMS}
        </OutlinedButton>
        <SectionStatusBadge status={completionData?.status} />
      </Box>
    </StyledPaper>
  );
}
